import { render, staticRenderFns } from "./PlaylistsPanel.vue?vue&type=template&id=4e4d6466"
import script from "./PlaylistsPanel.vue?vue&type=script&lang=js"
export * from "./PlaylistsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports